/* import __COLOCATED_TEMPLATE__ from './select.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import FormatSelectedValueAsText from 'embercom/helpers/format-selected-value-as-text';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

interface SelectItem {
  value: string;
  text: string;
}

interface Signature {
  Args: {
    selectedValue: string;
    items: SelectItem[];
    isReadOnly: boolean;
    hasError: boolean;
    onSelectItem: (value: string | null) => void;
    autofocus: boolean;
    filterPlaceholder: string;
  };
  Element: HTMLDivElement;
}

export default class Select extends Component<Signature> {
  @service declare inboxHotkeys: any;
  @tracked editMode = false;

  // @ts-ignore
  formatSelectedValueAsTextHelper = FormatSelectedValueAsText.create(this);

  get readOnlySelectValue(): string {
    return (
      this.formatSelectedValueAsTextHelper.compute([this.args.selectedValue, this.args.items]) ||
      '-'
    );
  }

  get selectedItemText(): string {
    let selectedItem = this.args.items?.find(
      (item: SelectItem) => item.value === this.args.selectedValue,
    );
    return selectedItem?.text || '';
  }

  @action
  enterEditMode(event: Event) {
    event.preventDefault();
    this.editMode = true;
    this.inboxHotkeys.disableHotkeys();
  }

  @action
  onOpen() {
    // Hotkeys already disabled in enterEditMode() - no-op here
    // Kept for potential future use if IcSelect opens without enterEditMode
  }

  @action
  onClose() {
    this.editMode = false;
    this.inboxHotkeys.enableHotkeys();
  }

  @action
  handleSelectItem(value: string | null) {
    this.args.onSelectItem(value);
    this.editMode = false;
    this.inboxHotkeys.enableHotkeys();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::TicketAttribute::Select': typeof Select;
    'inbox2/ticket-attribute/select': typeof Select;
  }
}
